import IconInfo from '../../assets/images/icon-info.svg';
import { useEffect, useState, useRef } from 'react';
import './Tooltip.css';

function Tooltip({ trigger = 'click', content, title }) {
  const [isShow, setIsShow] = useState(false);
  const [position, setPosition] = useState('bottom');
  const [coordinates, setCoordinates] = useState({
    x: 0,
    y: 0
  });

  const refTooltip = useRef();

  const handleClickOutside = (event) => {
    if (refTooltip.current && !refTooltip.current.contains(event.target)) {
      setIsShow(false);
    }
  };

  const handleMouseIn = () => {
    setIsShow(true);
  };

  const handleMouseOut = () => {
    setIsShow(false);
  };

  const handleClick = (e) => {
    setIsShow(state => !state);
    const distanceX = window.innerWidth - e.clientX;
    let tooltipWrapperWidth = 350;
    if (window.innerWidth < 480) {
      tooltipWrapperWidth = 270;
    }
    if (distanceX < 180) {
      setPosition('left');
      setCoordinates({
        x: e.clientX - tooltipWrapperWidth - e.currentTarget.offsetWidth,
        y: e.clientY
      });
    } else {
      setCoordinates({
        x: e.clientX,
        y: e.clientY
      });
    }
  };

  useEffect(() => {
    const onScroll = () => setIsShow(false);
    
    document.addEventListener('click', handleClickOutside, true);
    document.addEventListener('scroll', onScroll, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
      document.removeEventListener('scroll', onScroll, true);
    };
  }, []);

  return (
    <div className="aad-tooltip"
      onMouseOver={trigger === 'hover' ? handleMouseIn : () => false}
      onMouseLeave={trigger === 'hover' ? handleMouseOut : () => false}
      onMouseDown={trigger === 'click' ? handleClick : () => false}
      ref={refTooltip}
    >
      <img src={IconInfo} alt="" width={20} />
      { isShow && (
        <div className={`aad-tooltip__body ${position}`} style={{left: coordinates.x, top: coordinates.y}}>
          {title && <h3 className="aad-tooltip__title">{title}</h3>}
          <div className="aad-tooltip__content">{content}</div>
        </div>
      )}
    </div>
  )
}

export default Tooltip;
